module.exports = __webpack_public_path__ + "static/media/message.d40fcd85.png";